module.exports = __webpack_public_path__ + "media/images/icons/filled/file-excel-7f48b34e8724231790a76b6c48660d89.svg";